import { HugeiconsIcon } from '@hugeicons/react'
import { Loading02Icon } from '@hugeicons/core-stroke-rounded'

const Loading = function () {
  return (
    <HugeiconsIcon
      icon={Loading02Icon}
      className="size-8 animate-spin text-primary-dark"
    />
  )
}

export default Loading
